import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useIdentity = (page = 1, term = null, status = null) => useQuery({ queryKey: ['identity', page, term, status], queryFn: async () => {
    const callback = await API.get(`/tools/identity/list?page=${page}${term ? `&term=${term}` : ''}${status ? `&status=${status}` : ''}`)
    return callback?.data
}})

export default useIdentity